export default "__VITE_ASSET__DAE4Ur65__"